fragment EngagementStats on EngagementStats {
    totalSentCount
    openCount
    clickCount
    replyCount
    permanentBounceCount
    unsubscribeCount
    openRate
    clickRate
    replyRate
    permanentBounceRate
    unsubscribeRate
}
